module.exports = __webpack_public_path__ + "static/scale-model-of-stonehenge-replica-in-odessa-texas-d663ba8a3588dc79cd4ba80ee2ca99ed.png";